import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { NavItems } from '@shared/Frontend/components/navItems'
import { Maybe, Template, Unit, unit } from 'ballerina-core'
import React from 'react'
import { getNavigation } from './navigation.api'
import { NavigationState } from './navigation.state'

export type NavigationContext = { slug: string }

export const NavigationTemplate = Template.Default<NavigationContext, NavigationState, Unit, Unit>(
  ({ context, setState }) => (
    <NavItemsLoaderTemplate
      context={{ ...context, promise: () => getNavigation(context.slug) }}
      setState={setState}
      foreignMutations={unit}
      view={unit}
    />
  )
)

const NavItemsLoaderTemplate = AsyncLoaderTemplate<Maybe<NavItems>>()
